import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class GeoCodeService {

    getLocations(address){
        return new Observable((observer) => {
            let geocoder = new google.maps.Geocoder();
            geocoder.geocode({'address': address }, (results, status) => {
                if (status == google.maps.GeocoderStatus.OK) {
                    observer.next(results);
                }
            });
        });
    }

    geocode(point, cb){
        return new google.maps.Geocoder().geocode(point, cb);
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/core/geo-code.service.ts